import * as components from './components'

export default [
  {
    path: '/guest',
    component: components.GuestLogin,
    name: 'guestLogin',
    props: true
  }
]



// WEBPACK FOOTER //
// ./src/app/guest/routes.js